import ReactGA from 'react-ga4';

const isProduction = import.meta.env.PROD;

// Initialize Google Analytics
export const initGA = () => {
  if (isProduction) {
    ReactGA.initialize('G-RVN9N2CEN0');
  }
};

// Track page views
export const trackPageView = () => {
  if (isProduction) {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }
};

// Track events
export const trackEvent = (category, action, label) => {
  if (isProduction) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};
